import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'navInfo',
  title: 'Nav Info',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Display content?',
      name: 'displayContent',
      type: 'boolean',
      initialValue: true,
    }),
    defineField({
      title: 'Content Type',
      name: 'type',
      type: 'string',
      options: {
        list: [
          { title: 'Text & Button', value: 'text' },
          { title: 'Contact Info', value: 'contact' },
        ],
      },
      initialValue: 'text',
      hidden: ({ parent }) => !parent?.displayContent,
    }),
    defineField({
      name: 'content',
      type: 'text',
      rows: 3,
      title: 'Content',
      hidden: ({ parent }) =>
        !parent?.displayContent || parent?.type !== 'text',
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
      hidden: ({ parent }) =>
        !parent?.displayContent || parent?.type !== 'text',
    }),
    defineField({
      title: 'Phone',
      name: 'phone',
      type: 'string',
      hidden: ({ parent }) =>
        !parent?.displayContent || parent?.type !== 'contact',
    }),
    defineField({
      title: 'Hours',
      name: 'hours',
      type: 'text',
      rows: 5,
      hidden: ({ parent }) =>
        !parent?.displayContent || parent?.type !== 'contact',
    }),
    defineField({
      title: 'Contact Link',
      name: 'email',
      type: 'link',
      hidden: ({ parent }) =>
        !parent?.displayContent || parent?.type !== 'contact',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare(selection) {
      const { title = 'New nav item...' } = selection
      return {
        title,
        subtitle: '',
      }
    },
  },
})